"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubjectAvatar = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const Group_1 = tslib_1.__importDefault(require("@mui/icons-material/Group"));
const Laptop_1 = tslib_1.__importDefault(require("@mui/icons-material/Laptop"));
const material_1 = require("@mui/material");
const ArgusUtils = tslib_1.__importStar(require("@mnemonic/pure-utils/ArgusUtils"));
const iconStyle = { padding: "20%", width: "100%", height: "100%" };
/**
 *
 * A component used to display the a user picture or an icon in case of group or user agent.
 * Subject is assumed to be a user if type is not "group" and "daemonAccount" is not included in flags.
 *
 * @example ### Basic example
 *
 * This examples shows a basic rendering of this component
 *
 * ```jsx live noInline
 * file://./__examples__/1_SubjectAvatar.jsx
 * ```
 * @category component
 */
const SubjectAvatar = ({ subject, sx, ...avatarProps }) => {
    const imageUrl = (0, react_1.useMemo)(() => (subject?.id ? `${ArgusUtils.getApiUrl()}/users/v2/user/${subject?.id}/picture` : undefined), [subject]);
    const isUserAgent = subject?.flags?.includes("daemonAccount");
    const newSx = [
        {
            backgroundColor: (theme) => theme.palette.primary.main,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
    ];
    if (!subject) {
        return (react_1.default.createElement(material_1.Skeleton, { variant: "circular" },
            react_1.default.createElement(material_1.Avatar, { sx: newSx })));
    }
    if (subject.type === "group") {
        return (react_1.default.createElement(material_1.Avatar, { alt: subject?.name, children: react_1.default.createElement(Group_1.default, { style: iconStyle }), color: "dark", ...avatarProps, sx: newSx }));
    }
    if (isUserAgent) {
        return react_1.default.createElement(material_1.Avatar, { alt: subject?.name, children: react_1.default.createElement(Laptop_1.default, { style: iconStyle }), ...avatarProps, sx: newSx });
    }
    /* Avatar component will fall back to first letter of alt text if imageUrl is undefined */
    return react_1.default.createElement(material_1.Avatar, { alt: subject?.name, src: imageUrl, color: "dark", ...avatarProps, sx: newSx });
};
exports.SubjectAvatar = SubjectAvatar;
